module.exports = {
    title: "VMS_惠合科技品牌营销管理平台_让营销服务数字智能化",
    description: "惠合科技VMS品牌营销管理平台为品牌方提供覆盖活动配置、数据追踪、资金监管到风险控制的全生命周期管理服务，实现品牌活动精准投放、百倍转化。",
    keywords: "营销活动管理,数据分析,资金账户监管,风险控制,惠合科技"
}